/**
 * Estados posibles de un ranking GRAU.
 * Deben mantenerse sincronizados con el enum RankingEstado del backend
 * (ap-manager-service/src/model/ranking.model.ts).
 */
export const RANKING_ESTADO = Object.freeze({
  CREADO:             0,
  PARTIDAS_VALIDADAS: 1,
  GRAU_CALCULADO:     2,
  GRAU_CONFIRMADO:    3,
});

/** Etiquetas legibles para mostrar en la UI */
export const RANKING_ESTADO_LABEL = Object.freeze({
  [RANKING_ESTADO.CREADO]:             'Creado',
  [RANKING_ESTADO.PARTIDAS_VALIDADAS]: 'Partidas validadas',
  [RANKING_ESTADO.GRAU_CALCULADO]:     'Grau calculado',
  [RANKING_ESTADO.GRAU_CONFIRMADO]:    'Grau confirmado',
});
